import { Navigate, Outlet } from "react-router-dom";
import { isTokenValid } from "./utils/tokenValidation";

const ProtectedRouteNotAuthenticated = ({ redirectTo = '/login' }: { redirectTo?: string }) => {
  const isAuthenticated = isTokenValid();

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} />;
  }

  return <Outlet />;
};

export default ProtectedRouteNotAuthenticated;